<template>
	<ProductProductDetails :hidden-specifications="blok?.hidden_specifications" />
</template>

<script setup lang="ts">
import type { BlokProductDetails } from "~/types/storyblok/storyblok";

interface Props {
	blok?: BlokProductDetails;
}

defineProps<Props>();
</script>
